import { Injectable } from '@angular/core';
import { Promotion, PromotionStatus } from '../../domain/models/promotion.model';
import { PromotionInput } from '../../domain/models/promotion-input.model';
import { CreatePromotionRequestDto, PromotionDto } from '../dtos/promotion.dto';

@Injectable()
export class PromotionMapper {
  public toPromotion(dto: PromotionDto): Promotion {
    return {
      id: dto.Id,
      organizationId: dto.OrganizationId,
      name: dto.Name,
      code: dto.Code,
      discountPct: dto.DiscountPct,
      serviceLabel: dto.ServiceLabel,
      validFrom: dto.ValidFrom,
      validTo: dto.ValidTo,
      usageLimit: dto.UsageLimit,
      usesCount: dto.UsesCount,
      isEnabled: dto.IsEnabled,
      status: dto.Status as PromotionStatus,
      createdAtUtc: dto.CreatedAtUtc,
      updatedAtUtc: dto.UpdatedAtUtc,
    };
  }

  public toCreateRequest(input: PromotionInput): CreatePromotionRequestDto {
    return {
      Name: input.name,
      Code: input.code,
      DiscountPct: input.discountPct,
      ServiceLabel: input.serviceLabel,
      ValidFrom: input.validFrom,
      ValidTo: input.validTo,
      UsageLimit: input.usageLimit,
      UsesCount: input.usesCount,
      IsEnabled: input.isEnabled,
    };
  }
}
